module.exports = __webpack_public_path__ + "img/09.69144a47.png";